import { render, staticRenderFns } from "./Page-404.vue?vue&type=template&id=e9631282&scoped=true&"
import script from "./Page-404.vue?vue&type=script&lang=js&"
export * from "./Page-404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9631282",
  null
  
)

export default component.exports